
        Component.define('home-hero-saches', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $slider         = $el.find('.wrapper-slider');
const $btnOpenModal   = $el.find('.btn-open-modal');

$slider.slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnFocus: false,
    pauseOnHover: false,
    fade: true,
    cssEase: 'linear',
});

        });